import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export const formAddNewSubentitySettingsList = [
  ContactSlugEnum.FirstName,
  ContactSlugEnum.Surname,
  ContactSlugEnum.Email,
  ContactSlugEnum.PhoneNumber,
  ContactSlugEnum.CompanyName,
  ContactSlugEnum.Country,
  ContactSlugEnum.State,
  ContactSlugEnum.City,
  ContactSlugEnum.Neighborhood,
  ContactSlugEnum.StreetAddress,
  ContactSlugEnum.StreetNumber,
  ContactSlugEnum.Postcode,
  ContactSlugEnum.TaxNumber,
]

export const HORIZONTAL_LINE_INDEXES = [3, 6, 14]
